import { getMethod } from "../../../../function/helper";

const getCities = async (id, set) => {
  const response = await getMethod("/address/v1/city/show/" + id);

  const cityArray = [{ value: 0, label: "..." }];
  if (response.data) {
    response.data.forEach(item =>
      cityArray.push({ value: item.id, label: item.faName })
    );
  }
  set(() => [...cityArray]);
};

export default getCities;
